/**
 * Created by hp on 2017/8/7.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'react-weui';
import {MainPopupTabItem} from '../main';
import axios from 'axios';
import qs from 'qs';

class MainPopupTab extends Component {
    constructor() {
        super();
        this.handleFinish = this.handleFinish.bind(this);
    }

    handleFinish() {
        const {mineCategories, isTabSubscribed} = this.props;
        let categories = mineCategories.filter((item) => {
            return item.id !== 0;
        });
        let categoryIds = categories.map((item) => {
           return item.id;
        });

        if (isTabSubscribed) {
            axios.post('/account/api_subscribe_category', qs.stringify({category: categoryIds}, {arrayFormat: 'brackets'})).then((res) => {
                if (res.data.code === 0) {
                    this.context.page.showAlert('订阅成功');
                    this.props.dispatch({type: 'MAIN_HIDE_POPUP_TAB'});
                }
            });
        } else {
            this.props.dispatch({type: 'MAIN_HIDE_POPUP_TAB'});
        }
        document.body.style.overflow = 'auto';
    }

    render() {
        const {showPopupTab, allCategories, mineCategories} = this.props;
        if (!showPopupTab) {
            return null;
        }

        return (
            <div className="main-popup-tab">
                <div className="mt-popup">
                    <Button className="mt-finish-btn" size="small" onClick={this.handleFinish}>完成</Button>

                    <MainPopupTabItem name="我的订阅" subCategories={mineCategories} isBindMine={true}/>

                    {allCategories.map((category) => (
                        <MainPopupTabItem key={category.id} name={category.name} subCategories={category.sub_category} isBindMine={false}/>
                    ))}
                </div>
            </div>
        )
    }
}

MainPopupTab.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    showPopupTab: state.main.showPopupTab,
    subscribedCategoryFlag: state.main.subscribedCategoryFlag,
    allCategories: state.main.category.data.all,
    mineCategories: state.main.category.data.subd,
    isTabSubscribed: state.main.isTabSubscribed,
}))(MainPopupTab);


// WEBPACK FOOTER //
// ./src/components/main/MainPopupTab.js